import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const Loader = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }
  return (
    <FontAwesomeIcon
      style={{ margin: 5 }}
      className="fa-spin"
      icon={faSpinner}
    />
  );
};

export default Loader;
